module.exports = __webpack_public_path__ + "img/Bear28.3af3c221.jpg";